module.exports = __webpack_public_path__ + "static/media/document.d74ee29b.png";